<div class="tabs_container_irlDetails" aria-live="assertive">
  <div class="tabsHeader" role="tablist" aria-label="Rail details">
    <div
      class="tab_base"
      [ngClass]="{ tab_select: selectedTab === TabNames.FareDetails }"
      (click)="selectTab(TabNames.FareDetails)"
      (keydown.enter)="selectTab(TabNames.FareDetails)"
      tabindex="0"
      role="tab"
      [attr.aria-selected]="selectedTab === TabNames.FareDetails"
      aria-controls="rail-details-fare-panel"
      id="rail-details-fare-tab"
      i18n="@@itemDetailsFaredetails"
    >
      Fare Details
    </div>
    <div
      class="tab_base"
      [ngClass]="{ tab_select: selectedTab === TabNames.RailLegTimes }"
      (keydown.enter)="selectTab(TabNames.RailLegTimes)"
      (click)="selectTab(TabNames.RailLegTimes)"
      tabindex="0"
      role="tab"
      [attr.aria-selected]="selectedTab === TabNames.RailLegTimes"
      aria-controls="rail-details-show-panel"
      id="rail-details-show-tab"
      i18n="@@itemDetailsRailtLegTimes"
    >
      Show Details
    </div>
  </div>
  @if (selectedTab === TabNames.FareDetails) {
    <div
      class="pane"
      role="tabpanel"
      aria-labelledby="rail-details-fare-tab"
      id="rail-details-fare-panel"
      Title="TabNames.FareDetails"
    >
      @for (railJourney of providerRailJourney; track railJourney; let leg = $index) {
        @if (providerRailJourney.length > 1) {
          <div class="type">legs {{ leg + 1 }}</div>
        }
        @if (
          railJourney?.second?.length &&
          (!selectedFare[leg] || selectedFare[leg]?.class === ClassType.Standard)
        ) {
          <div class="type">2nd class</div>
        }
        <div class="tickets">
          @for (option of railJourney.second; track option) {
            @if (!selectedFare[leg] || selectedFare[leg]?.fareHash === option.fareHash) {
              <div class="ticket">
                <span class="leg">
                  <div>
                    <b>{{ option.class | translate }}:</b>
                  </div>
                  <label class="ticket-option-type">{{ option.type }}</label>
                  @if (option.identifiers?.fares[0]?.comfortClass) {
                    <label class="ticket-option-type">{{
                      option.identifiers?.fares[0]?.comfortClass
                    }}</label>
                  }
                  <a
                    class="fare_rules_link"
                    (click)="openFareRulesModal(option)"
                    (keydown.enter)="openFareRulesModal(option)"
                    tabindex="0"
                    role="link"
                  >
                    <i class="currency_info_icon"></i>
                    <span i18n="@@irlTypeBrandedFareRules">Fare Rules</span></a
                  ><br />
                </span>
                <span class="floatright">
                  <div class="irl-price-details">
                    <div class="star-container"></div>
                    <div class="cost" id="price">
                      {{ option.price | currency: option.currency : 'symbol' }}
                      @if (discountCard) {
                        <section (mouseleave)="tt1.close()">
                          <span
                            class="percentage-icon"
                            tooltipClass="custom-tooltip"
                            i18n-ngbTooltip
                            [ngbTooltip]="discountCard"
                            triggers="manual"
                            #tt1="ngbTooltip"
                            (mouseenter)="tt1.open()"
                            (focus)="tt1.open()"
                            (blur)="tt1.close()"
                            tabindex="0"
                            >%</span
                          >
                        </section>
                      }
                    </div>
                    <div class="star-container">
                      <app-warning-tags
                        [iconId]="option.fareHash"
                        [ticket]="option"
                      ></app-warning-tags>
                    </div>
                  </div>
                  <button (click)="addToBasket(option, leg)" [disabled]="isCancelled" class="link">
                    {{
                      (selectedFare[leg]?.fareHash === option.fareHash ? 'Deselect' : 'Select')
                        | translate
                    }}
                  </button>
                  <br />
                </span>
                @if (showDebug) {
                  <button (click)="alwaysLog(option)">Dump</button>
                }
              </div>
            }
          }
        </div>
        @if (
          railJourney?.first?.length &&
          (!selectedFare[leg] || selectedFare[leg]?.class === ClassType.First)
        ) {
          <div class="type">1st class</div>
        }
        <div class="tickets">
          @for (option of railJourney.first; track option) {
            @if (!selectedFare[leg] || selectedFare[leg]?.fareHash === option.fareHash) {
              <div class="ticket">
                <span class="leg">
                  <div>
                    <b>{{ option.class }}:</b>
                  </div>
                  <div>
                    <label class="ticket-option-type">{{ option.type }}</label>
                    @if (option.identifiers?.fares[0]?.comfortClass) {
                      <label class="ticket-option-type">{{
                        option.identifiers?.fares[0]?.comfortClass
                      }}</label>
                    }
                  </div>
                  <a
                    class="fare_rules_link"
                    (click)="openFareRulesModal(option)"
                    (keydown.enter)="openFareRulesModal(option)"
                    tabindex="0"
                    role="link"
                  >
                    <i class="currency_info_icon"></i>
                    <span i18n="@@irlTypeBrandedFareRules">Fare Rules</span></a
                  ><br />
                </span>
                <span class="floatright">
                  <div class="irl-price-details">
                    <div class="cost">
                      {{ option.price | currency: option.currency : 'symbol' }}
                      @if (discountCard) {
                        <section (mouseleave)="tt2.close()">
                          <span
                            class="percentage-icon"
                            tooltipClass="custom-tooltip"
                            i18n-ngbTooltip
                            [ngbTooltip]="discountCard"
                            triggers="manual"
                            #tt2="ngbTooltip"
                            (mouseenter)="tt2.open()"
                            (focus)="tt2.open()"
                            (blur)="tt2.close()"
                            tabindex="0"
                            >%</span
                          >
                        </section>
                      }
                    </div>
                    <div class="star-container">
                      <app-warning-tags
                        [iconId]="option.fareHash"
                        [ticket]="option"
                      ></app-warning-tags>
                    </div>
                  </div>
                  <button
                    (click)="addToBasket(option, leg)"
                    [disabled]="option?.unavailable || isCancelled"
                    class="link"
                  >
                    {{
                      (selectedFare[leg]?.fareHash === option.fareHash ? 'Deselect' : 'Select')
                        | translate
                    }}
                  </button>
                  <br />
                </span>
              </div>
            }
          }
        </div>
      }
    </div>
  }
  @if (selectedTab === TabNames.RailLegTimes) {
    <div
      class="pane"
      role="tabpanel"
      aria-labelledby="rail-details-show-tab"
      id="rail-details-show-panel"
    >
      <div class="leg_wrapper">
        <div class="leg_container">
          <app-irl-legs [legs]="legs" [trainNumber]="trainNumber"> </app-irl-legs>
        </div>
      </div>
    </div>
  }
</div>
